module.exports = __webpack_public_path__ + "static/wpwa-d3822db0d5edd58e823e7bbab3e1c319.png";